<template>
  <div class="space-y-4">
    <base-card
      title="Detail Pengiriman"
      :description="`Detail pengiriman ke ${officeLabel}`"
    >
      <div class="grid grid-cols-3 gap-6 border-t pt-5">
        <div>
          <dt class="text-xs text-gray-700">No Pengemasan</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ stockMovement.data.attributes.code }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">No Faktur</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            <button v-if="order" class="font-bold text-gray-900 inline-flex items-center gap-1" @click="detailModalVisible = true">
              {{ order.attributes.origin_code }} /
              {{ order.attributes.destination_code }}

              <Icon icon="heroicons:arrow-top-right-on-square" />
            </button>
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Tanggal Pengemasan</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ stockMovement.data.attributes.updatedAt | formatDate }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Kode {{ officeLabel }}</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ office ? office.attributes.code : '-' }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Nama {{ officeLabel }}</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ office ? office.attributes.name : '-' }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Alamat {{ officeLabel }}</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{
              office
                ? office.attributes.full_address
                : '-'
            }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Nomor Telepon {{ officeLabel }}</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ office ? office.attributes.phone : '-' }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Metode Pengiriman</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ order.attributes.order_shipment === 'pickup' ? 'Diambil' : 'Dikirim' }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-700">Tipe Faktur</dt>
          <dd class="mt-1 text-sm font-bold text-gray-900">
            {{ getTypeLabel }}
          </dd>
        </div>
      </div>
    </base-card>

    <base-card
      v-if="type === 'order' && order && order.attributes.complete_shipment_address && order.attributes.order_shipment === 'delivery'"
      :title="`Alamat ${
        order.attributes.order_shipment === 'pickup'
          ? 'Pengambilan'
          : 'Pengiriman'
      }`"
      :description="`Detail alamat ${
        order.attributes.order_shipment === 'pickup'
          ? 'pengambilan'
          : 'pengiriman'
      }`"
    >
      <base-input inset disabled label="Alamat">
        {{
          order.attributes.receipt_name || destinationOffice.attributes.name
        }},
        {{
          order.attributes.receipt_phone || destinationOffice.attributes.phone
        }},
        {{ order.attributes.complete_shipment_address }}
      </base-input>
    </base-card>

    <view-order-modal
      v-if="order"
      :with-payment="false"
      with-bonus
      :order-detail-columns="['code', 'qty', 'price', 'total_price', 'packed_qty', 'unpacked_qty']"
      :columns="[
        'code',
        'warehouse',
        'office',
        'date',
        'user',
        'area',
        'shipment_type',
        'address',
      ]"
      readonly
      :label="label"
      :visible="detailModalVisible"
      :order-id="order.id"
      :order-type="type"
      @close="detailModalVisible = false"
    />
  </div>
</template>

<script>
import ViewOrderModal from '../order/view-order-modal.vue';

export default {
  components: { ViewOrderModal }, 
  props: {
    stockMovement: Object,
    type: {
      type: String,
      default: 'order'
    },
    label: String
  },
  data() {
    return {
      detailModalVisible: false,
    }
  },
  computed: {
    destinationOffice() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships['destination-office'].data.id
      );
    },
    originOffice() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships['origin-office'].data.id
      );
    },
    office() {
      return this.destinationOffice
    },
    order() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships.order.data.id
      );
    },
    officeLabel() {
      return {
        'kantor_pelayanan': 'Kantor Pelayanan',
        'stockist_center': 'Stockist Center',
        'stockist': 'Stockist'
      }[this.destinationOffice ? this.destinationOffice.attributes.office_type : 'stockist']
    },
    getTypeLabel() {
      if (this.type === 'reimbursement') {
        return 'Reimbursement'
      }

      if (this.type === 'free_reimbursement') {
        return 'Susulan Promo'
      }

      if (this.order.attributes.is_transfer_promo || this.order.attributes.is_transfer_promo_regular) {
        return 'Kirim Promo'
      }

      if (['stockist_center', 'kantor_pelayanan'].includes(this.destinationOffice.attributes.office_type)) {
        return 'Restock'
      }

      return 'Penjualan'
    }
  }
}
</script>